/** Path length (px) that counts as more than a speck on SignatureCanvas. */
export const MIN_SIGNATURE_STROKE_PX = 160;

export function signatureStrokeLengthPx(
  strokes: ReadonlyArray<ReadonlyArray<{ x: number; y: number }>>,
): number {
  let length = 0;
  for (const stroke of strokes) {
    for (let i = 1; i < stroke.length; i++) {
      const dx = stroke[i].x - stroke[i - 1].x;
      const dy = stroke[i].y - stroke[i - 1].y;
      length += Math.hypot(dx, dy);
    }
  }
  return length;
}

export function hasReasonableSignatureStrokes(
  strokes: ReadonlyArray<ReadonlyArray<{ x: number; y: number }>>,
): boolean {
  return signatureStrokeLengthPx(strokes) >= MIN_SIGNATURE_STROKE_PX;
}
